import { useQuery } from "@tanstack/react-query";

import { campaignJobBoardQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";

export interface CampaignBudgetMinimums {
  minimumMonthlyBudget: number | null;
  minimumBudgetPerVacancy: number | null;
  vacancyCount: number;
}

interface UseCampaignBudgetMinimumsParams {
  campaignId: string;
  clientIntegrationModuleId?: string;
}

export function useCampaignBudgetMinimums({
  campaignId,
  clientIntegrationModuleId,
}: UseCampaignBudgetMinimumsParams) {
  return useQuery<CampaignBudgetMinimums>({
    queryKey: campaignJobBoardQueryKeys.budgetMinimums(
      campaignId,
      clientIntegrationModuleId ?? "",
    ),
    queryFn: () =>
      instance
        .get<CampaignBudgetMinimums>(
          `/api/v2/Campaigns/${campaignId}/Integrations/${clientIntegrationModuleId}/BudgetMinimums`,
        )
        .then((res) => res.data),
    enabled: !!campaignId && !!clientIntegrationModuleId,
    staleTime: 0,
    refetchOnMount: "always",
  });
}
